import type {i18n} from 'i18next'
import {TranslationKey, TranslationOptions} from 'notability-services-common-universal'
import {useTranslation as useTranslationOriginal} from 'react-i18next'

/**
 * Generate a hook for translating, with strong typing to ensure presence of the key being used.
 *
 * NOTE: If you're having trouble using a translation string you've added to `en.json`, make sure
 * to run `bun run translate` to add your new string to the list.
 */
type UseTranslation = () => {
  t<K extends TranslationKey>(key: K, options?: TranslationOptions<K>): string
  i18n: i18n
  ready: boolean
}
export type TranslationFunction = ReturnType<UseTranslation>['t']

export const useTranslation = useTranslationOriginal as UseTranslation

export type T = ReturnType<UseTranslation>['t']

// Backwards compatibility exports
export {useTranslation as useGLTranslation}
export type GLTFunction = TranslationFunction
